import { RouterOutputs } from "~/utils/api";
import { CommunityFormType } from "./CommunityPageTypes";
import { FaInstagram, FaReddit, FaYoutube } from "react-icons/fa";
import { FaX } from "react-icons/fa6";
import { GetCommunityDetailsAndExtraDetails } from "~/utils/community-queries";

type CommunityWithDetails =
    GetCommunityDetailsAndExtraDetails["communityDetails"];

export const getDefaultCommunityFormValues = (
    community?: CommunityWithDetails,
) => {
    if (!community) return;

    const defValues: CommunityFormType = {
        communityId: community.id,
        images: {
            image: community.image ?? "",
            coverImage: community.coverImage ?? "",
        },
        bannersBg: community.bannersBg,
        name: community.name,
        slug: community.slug,
        description: community.description,
        socials: community.socials ?? [
            { url: "" },
            { url: "" },
            { url: "" },
            { url: "" },
        ],
        mainLinks: community.mainLinks ?? [
            { name: "", url: "" },
            { name: "", url: "" },
            { name: "", url: "" },
            { name: "", url: "" },
        ],
        otherLinks: community.otherLinks ?? [
            { name: "", url: "" },
            { name: "", url: "" },
        ],
        categories: community.categories ?? [],
    };

    return defValues;
};

export const socialLinkFields = [
    {
        name: "socials.0.url",
        id: "socialMediaYoutube",
        label: "Youtube",
        type: "x",
        icon: <FaYoutube />,
        placeholder: "https://www.youtube.com/my-community",
    },
    {
        name: "socials.1.url",
        id: "socialMediaX",
        label: "X / Twitter",
        type: "ig",
        icon: <FaX />,
        placeholder: "https://www.x.com/my-community",
    },
    {
        name: "socials.2.url",
        id: "socialMediaIg",
        label: "Instagram",
        type: "li",
        icon: <FaInstagram />,
        placeholder: "https://www.instagram.com/my-community",
    },
    {
        name: "socials.3.url",
        id: "socialMediaReddit",
        label: "Reddit",
        type: "li",
        icon: <FaReddit />,
        placeholder: "https://www.reddit.com/r/my-community",
    },
] as const;

export const bgBannerColors = [
    {
        id: "r1",
        value: "linear-gradient(135deg, #1E3A8A 20%, rgba(96,165,250, 0.8) 80%)",
    },
    {
        id: "r2",
        value: "linear-gradient(135deg, #065F46 20%, rgba(52,211,153, 0.8) 80%)",
    },
    {
        id: "r3",
        value: "linear-gradient(135deg, #9A3412 20%, rgba(251,146,60, 0.8) 80%)",
    },
] as const;
